import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let LinkBoxComp;

class Link_box extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: LinkBoxComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/link-box-comp" */
            "../../../components/javascript/zcat-components/link-box-comp"
        ).then(function(res) {
            LinkBoxComp = res.LinkBoxComp;
        }));

        
;
    }
}

export {Link_box};

